import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */

/* eslint-disable react/prop-types */


import React, { Component } from 'react';
import Spinner from '@atlaskit/spinner';
import CommonCell from './common-cell';
import { LoaderItemContainer, TreeRowContainer } from './styled';

var LoaderItem = /*#__PURE__*/function (_Component) {
  _inherits(LoaderItem, _Component);

  var _super = _createSuper(LoaderItem);

  function LoaderItem() {
    var _this;

    _classCallCheck(this, LoaderItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      phase: 'loading'
    });

    return _this;
  }

  _createClass(LoaderItem, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.phase === 'loading' && this.state.phase === 'complete') {
        if (this.props.onComplete) {
          this.props.onComplete();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var depth = this.props.depth;
      var phase = this.state.phase;
      return phase === 'loading' ? /*#__PURE__*/React.createElement(TreeRowContainer, null, /*#__PURE__*/React.createElement(CommonCell, {
        indent: "".concat(25 * depth, "px"),
        width: "100%"
      }, /*#__PURE__*/React.createElement(LoaderItemContainer, {
        isRoot: depth === 1
      }, /*#__PURE__*/React.createElement(Spinner, {
        size: "small"
      })))) : null;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.isCompleting && prevState.phase === 'loading') {
        return {
          phase: 'complete'
        };
      }

      return null;
    }
  }]);

  return LoaderItem;
}(Component);

_defineProperty(LoaderItem, "defaultProps", {
  depth: 1
});

export { LoaderItem as default };